module.exports = __webpack_public_path__ + "img/gongsirongyu.807e809d.png";